import { render, staticRenderFns } from "./FeedbackTest.vue?vue&type=template&id=233716b9&scoped=true"
import script from "./FeedbackTest.vue?vue&type=script&lang=js"
export * from "./FeedbackTest.vue?vue&type=script&lang=js"
import style0 from "./FeedbackTest.vue?vue&type=style&index=0&id=233716b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233716b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
